exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "table th,td{text-align:center}", "", {"version":3,"sources":["D:/xampp/htdocs/PhotoGenius_V2/src/components/addmail.vue"],"names":[],"mappings":"AACA,YAEE,iBAAmB,CACpB","file":"addmail.vue","sourcesContent":["\ntable th,\r\ntd {\r\n  text-align: center;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e8cbd18","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/addmail.vue
// module id = 335
// module chunks = 6